import { Component, ElementRef } from '@angular/core';
import { ModalAreaComponent, ModalService } from '@vhv/tarifrechner-common';

@Component({
    selector: 'cyber-modal-area',
    templateUrl: 'cyber-modal-area.component.html',
    host: {
        class: 'm-modal-area',
    },
})
export class CyberModalAreaComponent extends ModalAreaComponent{

    constructor(
        modalService: ModalService,
    ) {
        super(modalService);
    }

}
